function CompetenceCard({ name, logo, id }) {
  return (
    <div className="competencecard">
      <img src={logo} className="competence_logo" alt="logo" />
    </div>
  );
}

export default CompetenceCard;
